package com.gsb.vyapar.bhagya.presentation.admin.view

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.Screens
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButton
import com.gsb.vyapar.bhagya.presentation.common.toolbar.Toolbar
import com.gsb.vyapar.bhagya.presentation.navigation.util.pushView

@Composable
fun AdminView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
        ) {
            Toolbar("Admin View")
            Column(Modifier.verticalScroll(rememberScrollState()).padding(horizontal = 16.dp)) {
                Spacer(Modifier.height(16.dp))
                GVBButton(text = "AddCategory") { pushView(Screens.AddCategory) }
                Spacer(Modifier.height(16.dp))
                GVBButton(text = "AdminCategories") { pushView(Screens.AdminCategories) }
                Spacer(Modifier.height(16.dp))
                GVBButton(text = "Info") { pushView(Screens.InfoScreen) }
                Spacer(Modifier.height(16.dp))
                GVBButton(text = "Config") { pushView(Screens.ConfigScreen) }
                Spacer(Modifier.height(16.dp))
                GVBButton(text = "Review Business") { pushView(Screens.ReviewBusiness) }
                Spacer(Modifier.height(16.dp))
                GVBButton(text = "Get User") { pushView(Screens.GetUser) }
                Spacer(Modifier.height(16.dp))
            }
        }
    }
}